// extracted by mini-css-extract-plugin
export var explainable = "_ib-a";
export var printerCard = "_ib-1";
export var printerCardConfigured = "_ib-2";
export var printerCardError = "_ib-3";
export var printerCardsContainer = "_ib-0";
export var printerIcon = "_ib-8";
export var printerIconConfigured = "_ib-5";
export var printerIconContainer = "_ib-4";
export var printerIconError = "_ib-6";
export var printerIconUnconfigured = "_ib-7";
export var workstationsTableCard = "_ib-9";